import React from 'react';
import MenuItem from '@material-ui/core/MenuItem';
import TextField from '@material-ui/core/TextField';
import * as XLSX from 'xlsx';

import {
  DataTable,
  toast,
  Button as DsButton,
  FilterSelect,
  Tag,
  Modal,
  criarCopiaDeColuna
} from '../../components/ds';
import visaoAPI from '../../api/visaoPessoas';

// Pedido de vale-transporte do mês (Visão de Pessoas › Benefícios ›
// Vale-transporte). Substitui a planilha Pedido_VT: as passagens de cada
// pessoa vêm do cadastro (Rio Card e/ou Jaé, valor x vezes por dia), os dias
// úteis são informados aqui uma vez para todos e as férias da ficha já saem
// dos dias de cada um.
//
//   6% = salário / dias do mês x 6% x dias trabalhados
//   funcionário (4.1.4) = menor entre 6% e o custo; empresa (2.1.3.1) = resto
//   2ª via do cartão entra na parte do funcionário.

const dinheiro = (v) =>
  v === null || v === undefined || v === ''
    ? '—'
    : Number(v).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });

const numero = (v) => (v === null || v === undefined || v === '' ? 0 : Number(v));

const rotuloCompetencia = (v) => {
  const [a, m] = String(v || '').split('-');
  return a && m ? `${m}/${a}` : '—';
};

// Do mês passado até três meses à frente: o pedido costuma ser feito antes
// do mês começar.
const competenciasOferecidas = () => {
  const hoje = new Date();
  const lista = [];
  for (let d = -6; d <= 3; d++) {
    const x = new Date(hoje.getFullYear(), hoje.getMonth() + d, 1);
    lista.push(`${x.getFullYear()}-${String(x.getMonth() + 1).padStart(2, '0')}`);
  }
  return lista.reverse();
};

const competenciaPadrao = () => {
  const hoje = new Date();
  // Depois do dia 15 o pedido em preparo já é o do mês seguinte.
  const x = new Date(hoje.getFullYear(), hoje.getMonth() + (hoje.getDate() > 15 ? 1 : 0), 1);
  return `${x.getFullYear()}-${String(x.getMonth() + 1).padStart(2, '0')}`;
};

const ehVerdadeiro = (v) => v === true || v === 't' || v === 'true';

// "1.234,56", "7,90" ou "7.90" -> número; vazio -> null.
const lerNumero = (v) => {
  const t = String(v === null || v === undefined ? '' : v).trim();
  if (t === '') return null;
  const n = parseFloat(t.indexOf(',') >= 0 ? t.replace(/\./g, '').replace(',', '.') : t);
  return Number.isNaN(n) ? NaN : n;
};

const paraCampo = (v) =>
  Number(v || 0).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });

// Cor de fundo das colunas de cada cartão, para o olho achar rápido o que é
// Rio Card e o que é Jaé numa tabela larga. Vai em style (célula) e
// headerStyle (cabeçalho) do react-table.
const corColuna = (fundo, cabecalho) => ({
  style: { background: fundo },
  headerStyle: { background: cabecalho }
});
const COR_RIOCARD = corColuna('#fff8db', '#fcefb4');
const COR_JAE = corColuna('#e6f2fb', '#cfe5f6');
const COR_TOTAL = corColuna('#e8f5e9', '#c8e6c9');

const mensagemErro = (e, padrao) => (e && e.response && e.response.message) || padrao;

class ValeTransporte extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      competencia: competenciaPadrao(),
      diasUteis: '',
      pedido: null,
      diasSugeridos: null,
      elegiveis: 0,
      foraDoPedido: 0,
      itens: [],
      totais: {},
      carregando: false,
      calculando: false,
      // Edição de uma linha
      edicao: null,
      edDias: '',
      edRio: '',
      edJae: '',
      edSegunda: '',
      edObs: '',
      salvando: false
    };
    this.copia = criarCopiaDeColuna();
  }

  componentDidMount() {
    this.carregar();
  }

  carregar = () => {
    this.setState({ carregando: true });
    visaoAPI
      .getPedidoVT(this.state.competencia)
      .then((r) => {
        const pedido = r.pedido || null;
        this.setState({
          carregando: false,
          pedido,
          diasSugeridos: r.dias_uteis_sugeridos,
          // Pedido gravado mostra os dias com que foi calculado; sem pedido,
          // sugere segunda a sexta do mês (feriado se tira à mão).
          diasUteis: String(pedido ? pedido.dias_uteis : r.dias_uteis_sugeridos || ''),
          elegiveis: r.elegiveis || 0,
          foraDoPedido: r.fora_do_pedido || 0,
          // total_pessoa: o pedido daquela pessoa (Rio Card + Jaé), para a
          // última coluna da tabela. Calculado aqui, e não no Cell, para a
          // cópia de coluna e a ordenação funcionarem como nas outras.
          itens: (r.request || []).map((l) => ({
            ...l,
            total_pessoa: Math.round((numero(l.valor_riocard) + numero(l.valor_jae)) * 100) / 100
          })),
          totais: r.totais || {}
        });
      })
      .catch((e) => {
        this.setState({ carregando: false });
        toast.error(mensagemErro(e, 'Não foi possível carregar o pedido de vale-transporte.'));
      });
  };

  trocarCompetencia = (evento) => {
    this.setState({ competencia: evento.target.value }, this.carregar);
  };

  calcular = () => {
    const dias = Number(this.state.diasUteis);
    if (!Number.isInteger(dias) || dias < 0 || dias > 31) {
      toast.error('Informe os dias úteis do mês (0 a 31).');
      return;
    }
    this.setState({ calculando: true });
    visaoAPI
      .gerarPedidoVT(this.state.competencia, dias)
      .then((r) => {
        this.setState({ calculando: false });
        toast.success(
          r.mantidas
            ? `${r.message}. ${r.mantidas} pessoa(s) sem VT no cadastro ficaram por terem ajuste manual.`
            : r.message || 'Pedido calculado.'
        );
        this.carregar();
      })
      .catch((e) => {
        this.setState({ calculando: false });
        toast.error(mensagemErro(e, 'Não foi possível calcular o pedido.'));
      });
  };

  abrirEdicao = (linha) => {
    this.setState({
      edicao: linha,
      edDias: String(linha.dias_trabalhados),
      edRio: paraCampo(linha.valor_riocard),
      edJae: paraCampo(linha.valor_jae),
      edSegunda: paraCampo(linha.valor_segunda_via),
      edObs: linha.observacao || ''
    });
  };

  fecharEdicao = () => this.setState({ edicao: null });

  // Manda só o que mudou: dias sozinhos refazem os valores pela tarifa da
  // linha; valor digitado fica marcado como ajustado.
  salvarEdicao = () => {
    const { edicao: l, edDias, edRio, edJae, edSegunda, edObs } = this.state;
    const alt = {};
    const dias = Number(edDias);
    if (!Number.isInteger(dias) || dias < 0 || dias > 31) {
      toast.error('Dias trabalhados de 0 a 31.');
      return;
    }
    if (dias !== Number(l.dias_trabalhados)) alt.dias_trabalhados = dias;

    const campos = [
      ['valor_riocard', edRio, 'Rio Card'],
      ['valor_jae', edJae, 'Jaé'],
      ['valor_segunda_via', edSegunda, '2ª via']
    ];
    for (let i = 0; i < campos.length; i++) {
      const [coluna, texto, rotulo] = campos[i];
      const n = lerNumero(texto);
      const valor = n === null ? 0 : n;
      if (Number.isNaN(valor) || valor < 0) {
        toast.error(`Valor de ${rotulo} inválido.`);
        return;
      }
      if (Math.abs(valor - numero(l[coluna])) >= 0.005) alt[coluna] = valor;
    }
    if ((edObs || '') !== (l.observacao || '')) alt.observacao = edObs;

    if (Object.keys(alt).length === 0) {
      this.fecharEdicao();
      return;
    }
    this.enviarEdicao(l, alt);
  };

  recalcularLinha = () => this.enviarEdicao(this.state.edicao, { recalcular: true });

  enviarEdicao = (linha, alt) => {
    this.setState({ salvando: true });
    visaoAPI
      .editarItemVT(this.state.competencia, linha.cpf_funcionario, alt)
      .then(() => {
        this.setState({ salvando: false, edicao: null });
        this.carregar();
      })
      .catch((e) => {
        this.setState({ salvando: false });
        toast.error(mensagemErro(e, 'Não foi possível salvar a linha.'));
      });
  };

  // Exporta o que a tabela mostra (busca aplicada): uma linha por conta e
  // por cartão, com CPF, Conta, Valor e Descrição lado a lado: funcionário
  // 4.1.4 (2ª via numa linha própria) e empresa 2.1.3.1. Valor zero não sai.
  exportar = () => {
    const { itens, competencia, pedido } = this.state;
    const visiveis = this.copia.linhas();
    const base = visiveis.length ? visiveis : itens;
    const COLUNAS = ['CPF', 'Conta', 'Valor', 'Descrição', 'Lançamento', 'Nome'];
    const descricao = `VALE TRANSPORTE ${rotuloCompetencia(competencia)}`;
    const partes = [
      ['func_riocard', '4.1.4', 'Funcionário Rio Card'],
      ['emp_riocard', '2.1.3.1', 'Empresa Rio Card'],
      ['func_jae', '4.1.4', 'Funcionário Jaé'],
      ['emp_jae', '2.1.3.1', 'Empresa Jaé'],
      ['valor_segunda_via', '4.1.4', 'Funcionário 2ª via do cartão']
    ];
    const linhas = [];
    base.forEach((l) => {
      partes.forEach(([coluna, conta, rotulo]) => {
        const valor = numero(l[coluna]);
        if (Math.abs(valor) < 0.005) return;
        linhas.push({
          CPF: l.cpf_funcionario,
          Conta: conta,
          Valor: valor,
          Descrição: descricao,
          Lançamento: rotulo,
          Nome: l.nome_funcionario
        });
      });
    });

    const total = Math.round(linhas.reduce((s, x) => s + x.Valor, 0) * 100) / 100;
    const ws = XLSX.utils.json_to_sheet(linhas.concat([{ CPF: 'TOTAL', Valor: total }]), { header: COLUNAS });
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, rotuloCompetencia(competencia).replace('/', '-'));
    XLSX.writeFile(
      wb,
      `Pedido_VT_${competencia}${pedido ? `_${pedido.dias_uteis}dias` : ''}.xlsx`
    );
  };

  colunas = () => [
    {
      Header: this.copia.cabecalho('Nome', 'nome_funcionario'),
      accessor: 'nome_funcionario',
      width: 240,
      Cell: (row) => (
        <span
          className="action-cell"
          style={{ color: '#2f6fa8', cursor: 'pointer' }}
          onClick={() => this.abrirEdicao(row.original)}
        >
          {row.value}
          {ehVerdadeiro(row.original.dias_ajustado) || ehVerdadeiro(row.original.valores_ajustado) ? (
            <span style={{ marginLeft: 8 }}>
              <Tag tone="orange" dot={false}>Ajustado</Tag>
            </span>
          ) : null}
        </span>
      )
    },
    this.copia.coluna('Projeto', 'projeto', { width: 100, formatar: (v) => v || '—' }),
    this.copia.coluna('Dias', 'dias_trabalhados', { width: 70 }),
    this.copia.coluna('Passagens Rio Card', 'tarifas_riocard', { width: 160, formatar: (v) => v || '—' }),
    this.copia.coluna('Rio Card', 'valor_riocard', { width: 120, formatar: dinheiro, ...COR_RIOCARD }),
    this.copia.coluna('Passagens Jaé', 'tarifas_jae', { width: 150, formatar: (v) => v || '—' }),
    this.copia.coluna('Jaé', 'valor_jae', { width: 120, formatar: dinheiro, ...COR_JAE }),
    this.copia.coluna('6% do salário', 'valor_6pct', { width: 130, formatar: dinheiro }),
    this.copia.coluna('Func. Rio Card(4.1.4)', 'func_riocard', { width: 130, formatar: dinheiro }),
    this.copia.coluna('Emp. Rio Card(2.1.3.1)', 'emp_riocard', { width: 140, formatar: dinheiro }),
    this.copia.coluna('Func. Jaé(4.1.4)', 'func_jae', { width: 120, formatar: dinheiro }),
    this.copia.coluna('Emp. Jaé(2.1.3.1)', 'emp_jae', { width: 120, formatar: dinheiro }),
    this.copia.coluna('2ª via', 'valor_segunda_via', { width: 110, formatar: dinheiro }),
    this.copia.coluna('Total funcionário', 'total_funcionario', { width: 150, formatar: dinheiro }),
    this.copia.coluna('Total empresa', 'total_empresa', { width: 140, formatar: dinheiro }),
    this.copia.coluna('Total', 'total_pessoa', { width: 130, formatar: dinheiro, ...COR_TOTAL }),
    this.copia.coluna('Observação', 'observacao', { width: 220, formatar: (v) => v || '' })
  ];

  render() {
    const {
      competencia, diasUteis, pedido, diasSugeridos, foraDoPedido, itens, totais,
      carregando, calculando, edicao, salvando
    } = this.state;

    const filtros = (
      <>
        {this.props.seletorPagina}
        <FilterSelect value={competencia} onChange={this.trocarCompetencia}>
          {competenciasOferecidas().map((c) => (
            <MenuItem key={c} value={c}>{rotuloCompetencia(c)}</MenuItem>
          ))}
        </FilterSelect>
      </>
    );

    const acoes = (
      <>
        <TextField
          label="Dias úteis"
          type="number"
          value={diasUteis}
          onChange={(e) => this.setState({ diasUteis: e.target.value })}
          inputProps={{ min: 0, max: 31 }}
          style={{ width: 100, marginRight: 8 }}
          helperText={diasSugeridos !== null ? `seg–sex: ${diasSugeridos}` : ''}
        />
        <DsButton intent="primary" disabled={calculando} onClick={this.calcular}>
          {calculando ? 'Calculando...' : pedido ? 'Recalcular para todos' : 'Calcular para todos'}
        </DsButton>
        <DsButton intent="outlined" disabled={itens.length === 0} onClick={this.exportar}>
          Exportar Excel
        </DsButton>
      </>
    );

    const resumo = [
      ['Rio Card', totais.valor_riocard],
      ['Jaé', totais.valor_jae],
      ['Total do pedido', numero(totais.valor_riocard) + numero(totais.valor_jae)],
      ['Funcionário (4.1.4)', totais.total_funcionario],
      ['Empresa (2.1.3.1)', totais.total_empresa],
      ['2ª via', totais.valor_segunda_via]
    ];

    return (
      <div>
        <p style={{ color: '#666', margin: '12px 0 4px' }}>
          {pedido
            ? `Calculado com ${pedido.dias_uteis} dia(s) útil(eis) em ${String(pedido.dt_calculo).slice(8, 10)}/${String(pedido.dt_calculo).slice(5, 7)}${pedido.calculado_por_nome ? ` por ${pedido.calculado_por_nome}` : ''}. Clique no nome para ajustar dias, valores, 2ª via ou observação.`
            : 'Pedido deste mês ainda não calculado. Confira os dias úteis (tire os feriados) e clique em Calcular para todos.'}
        </p>
        {foraDoPedido > 0 ? (
          <p style={{ color: '#8a6d3b', margin: '0 0 8px' }}>
            {pedido
              ? `${foraDoPedido} pessoa(s) com vale-transporte no cadastro ainda não estão neste pedido. Recalcule para incluir.`
              : `${foraDoPedido} pessoa(s) com vale-transporte e passagens no cadastro entram no cálculo.`}
          </p>
        ) : null}

        {itens.length > 0 ? (
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: 24, padding: '8px 0 12px' }}>
            {resumo.map(([titulo, valor]) => (
              <div key={titulo}>
                <div style={{ fontSize: 12, color: '#666' }}>{titulo}</div>
                <div style={{ fontSize: 16, fontWeight: 500 }}>{dinheiro(numero(valor))}</div>
              </div>
            ))}
          </div>
        ) : null}

        <DataTable
          actions={acoes}
          filters={filtros}
          data={itens}
          columns={this.colunas()}
          className="ds-table -highlight ds-table--scroll-x"
          getTableProps={this.copia.capturarLinhasVisiveis}
          loading={carregando}
          defaultPageSize={20}
          showSearch
          showTotal
          searchPlaceholder="Buscar por nome ou CPF"
          noDataText={pedido ? 'Ninguém neste pedido' : 'Pedido ainda não calculado'}
        />

        <Modal
          isOpen={!!edicao}
          onClose={this.fecharEdicao}
          title={edicao ? edicao.nome_funcionario : ''}
          maxWidth="sm"
          fullWidth
        >
          {edicao ? (
            <div>
              <p style={{ marginTop: 0, color: '#666' }}>
                Passagens: {[
                  edicao.tarifas_riocard ? `Rio Card ${edicao.tarifas_riocard}` : null,
                  edicao.tarifas_jae ? `Jaé ${edicao.tarifas_jae}` : null
                ].filter(Boolean).join(' · ') || '—'}
                {' · '}Salário {dinheiro(edicao.salario_base)}
              </p>
              <div style={{ display: 'flex', flexWrap: 'wrap', gap: 16 }}>
                <TextField
                  label="Dias trabalhados"
                  type="number"
                  inputProps={{ min: 0, max: 31 }}
                  value={this.state.edDias}
                  onChange={(e) => this.setState({ edDias: e.target.value })}
                  helperText="Muda os valores pela passagem do dia"
                  style={{ width: 200 }}
                />
                <TextField
                  label="Rio Card (R$)"
                  value={this.state.edRio}
                  onChange={(e) => this.setState({ edRio: e.target.value })}
                  style={{ width: 150 }}
                />
                <TextField
                  label="Jaé (R$)"
                  value={this.state.edJae}
                  onChange={(e) => this.setState({ edJae: e.target.value })}
                  style={{ width: 150 }}
                />
                <TextField
                  label="2ª via do cartão (R$)"
                  value={this.state.edSegunda}
                  onChange={(e) => this.setState({ edSegunda: e.target.value })}
                  helperText="Desconta do funcionário"
                  style={{ width: 200 }}
                />
              </div>
              <TextField
                label="Observação"
                fullWidth
                value={this.state.edObs}
                onChange={(e) => this.setState({ edObs: e.target.value.slice(0, 255) })}
                style={{ marginTop: 16 }}
              />
              <p style={{ fontSize: 13, color: '#666' }}>
                6% {dinheiro(edicao.valor_6pct)} · Funcionário {dinheiro(edicao.total_funcionario)} ·
                Empresa {dinheiro(edicao.total_empresa)}
                {ehVerdadeiro(edicao.dias_ajustado) || ehVerdadeiro(edicao.valores_ajustado)
                  ? ' · Linha com ajuste manual: o recálculo geral mantém o que foi digitado.'
                  : ''}
              </p>
              <div style={{ marginTop: 16, display: 'flex', justifyContent: 'space-between' }}>
                <DsButton intent="text" disabled={salvando} onClick={this.recalcularLinha}>
                  Recalcular pelo cadastro
                </DsButton>
                <span>
                  <DsButton intent="text" onClick={this.fecharEdicao}>Cancelar</DsButton>
                  <DsButton intent="primary" disabled={salvando} onClick={this.salvarEdicao}>
                    {salvando ? 'Salvando...' : 'Salvar'}
                  </DsButton>
                </span>
              </div>
            </div>
          ) : null}
        </Modal>
      </div>
    );
  }
}

export default ValeTransporte;
